import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { BREADCRUMBS_IDS } from "../constants/BreadcrumbsIds";
import { PAGE_URLS } from "../constants/PageUrls";
import { TEST_IDS } from "../constants/TestIds";
import { TRANSLATION_KEYS } from "../constants/TranslationKeys";

import type { BreadcrumbItem } from "modules/common";

export function useConnectBreadcrumbs(): BreadcrumbItem[] {
  const { t } = useTranslation("connect");

  return useMemo(
    (): BreadcrumbItem[] => [
      {
        id: BREADCRUMBS_IDS.connect,
        title: t(TRANSLATION_KEYS.connect),
        "data-testid": TEST_IDS.connectBreadcrumb,
        url: PAGE_URLS.connect,
      },
    ],
    [t]
  );
}
